import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import { ChatIcon } from '@atlaskit/legacy-custom-icons';
export var ChatPillIcon = function ChatPillIcon(props) {
  return /*#__PURE__*/React.createElement(AiChatIcon, _extends({}, props, {
    label: "",
    LEGACY_size: "small",
    LEGACY_fallbackIcon: ChatIcon
  }));
};